<div class="container-fluid h-100 readOnlyForm pl-0 pr-0">

  <!-- Section header start -->
  <div class="headerBackground card p-1 mb-2 tool-header-height">
    <div class="row padding2px">
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 sectionHeaderIcon">
        <span>
          <fa-icon class="fas fa-lg autoCursor" [icon]="faTasks"></fa-icon>
        </span>
      </div>
      <div class="col col-3 col-md-3 col-lg-3 col-sm-3 col-xs-4">
        <h6 class="headerFontSize">{{ 'menu.sprintPlanner' | translate }}</h6>
      </div>
      <div class="col col-7 col-md-7 col-lg-7 col-sm-7 col-xs-6">
        <p class="titleParagraph">{{'sprintPlanner.toolHeaderLine1' | translate}}<br>
          {{'sprintPlanner.toolHeaderLine2' | translate}}
        </p>
      </div>
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1">
        <div class="dropGroupBtn marginbottom5px">
          <span>
            <a id="taskPlannerYoutube" type="button" class="" data-toggle="modal" data-target="#ytVideoLinkTP1">
              <fa-icon class="fas" [icon]="faInfoCircle" title="help"></fa-icon>
            </a>
          </span>
        </div>
        <div class="dropGroupBtn marginbottom5px">
          <span type="button" (click)="sprintName && generateReport('true')">
            <fa-icon class="fas" [icon]="faFileExport" title="report"></fa-icon>
          </span>
        </div>
      </div>
    </div>
  </div>
  <!-- Section header end -->

  <div class="environ-designer tool-body-height">
    <div class="card p-1 h-100 bg-white">
      <div class="row full-width p-1">
        <div class="col-xs-12">
          <div class="row strict">
            <div class="col col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-9 paddingleft3px paddingright3px">
              <div class="row strict">

                <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 dropdown" *ngIf="!showText">
                  <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                    [ngClass]="{ dis:sprintNamesArray.length<=0}" type="button" data-toggle="dropdown">
                    <div class="row strict">
                      <div class="col-xs-10 span-on-button ">
                        <span *ngIf="sprintNamesArray.length>0">
                          {{sprintName || 'sprintPlanner.chooseSprintHeading' | translate }}
                        </span>
                        <span *ngIf="sprintNamesArray.length<=0">
                          {{sprintName || 'sprintPlanner.addSprint' | translate }}
                        </span>
                      </div>
                      <div class="col-xs-1 col-xs-offset-1 pull-right ">
                        <span class="caret"></span>
                      </div>
                    </div>
                  </button>
                  <ul class="dropdown-menu">
                    <li [ngClass]="{displayNone:sprintNamesArray.length<=0}"
                      (click)="selectedSprint(false,false,sprint.sprintName)"
                      *ngFor="let sprint of sprintNamesArray; let tabIndex = index">
                      <a>{{sprint.sprintName}}</a>
                    </li>
                    <li *ngIf="!(sprintNamesArray.length > 0)" [ngClass]="{ dis:sprintNamesArray.length<=0}">
                      <div class="col-xs-12 alert mb-0 p-0">
                        <strong>{{ 'sprintPlanner.emptySprintList' | translate }}</strong>
                      </div>
                    </li>
                  </ul>
                </div>

                <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12" *ngIf="showText">
                  <input id="taskPlannerInputField" type="text"
                    [placeholder]="'sprintPlanner.sprintNamePlaceholder'| translate" [(ngModel)]='sprintName'
                    class="form-control strict lg-input pl-3 pr-3 taskplanner-inputfield"
                    (keyup.enter)="sprintNameChanged(sprintName,oldSprintName, updateSprintname)">
                </div>
              </div>
            </div>
            <div class="col col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-2 paddingleft3px paddingright3px">
              <div class="row strict">
                <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1 mapperReadOnly">
                  <div>
                    <button type="button" [ngClass]="{ dis:showText==true}"
                      class="btn btn-default btn-block btn-sm tpButton" (click)="selectedSprint(true,true,'')">
                      <fa-icon class="fa menuItemsClrBlack" [icon]="faPlus"></fa-icon>
                    </button>
                  </div>
                </div>
                <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1 mapperReadOnly">
                  <div>
                    <button type="button" class="btn btn-block btn-default btn-sm tpButton"
                      [ngClass]="{ dis:showText==true || new==true}" (click)="editSprintname(sprintName)">
                      <fa-icon class="fas menuItemsClrBlack" [icon]="faEdit"></fa-icon>
                    </button>
                  </div>
                </div>

                <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1 mapperReadOnly">
                  <div *ngIf="showText">
                    <button type="button" class="btn btn-default btn-block btn-sm tpButton" (click)="clear()">
                      <fa-icon class="fas menuItemsClrBlack" [icon]="faTimes"></fa-icon>
                    </button>
                  </div>
                  <div *ngIf="!showText">
                    <button id="delPlanButton" type="button" data-toggle="modal"
                      data-target="#newTPplanDeleteConfirmModel" class="btn btn-block btn-default btn-sm tpButton"
                      [ngClass]="{ dis:showText==true || sprintName == ''}">
                      <fa-icon class="fas menuItemsClrBlack" [icon]="faTrashAlt"></fa-icon>

                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row strict sprint-planner-filter-table-section-height">
        <div class="col-xs-12 pl-0 h-100">
          <div class="row strict h-100" *ngIf="step == '1' || step == undefined">
            <div class="row full-width p-1 h-100">
              <div class="col-xs-12 h-100">
                <div class="row strict">
                  <!-- user story type selection dropdown -->
                  <div class="col col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1 paddingleft3px paddingright3px">
                    <div class="row strict">
                      <div class="col-sm-12 col-xs-12">

                        <div class="dropdown">
                          <button
                            class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                            type="button" data-toggle="dropdown" [ngClass]="{ dis:sprintName == ''}">
                            <!-- [ngClass]="{ dis:activityDisabled}" -->
                            <div class="row strict">
                              <div class="col-xs-10 text-flow">
                                <span>{{selectedActivity||'sprintPlanner.chooseIssueType' | translate }}</span>
                              </div>
                              <div class="col-xs-1 col-xs-offset-1 pull-right ">
                                <span class="caret"></span>
                              </div>
                            </div>
                          </button>
                          <ul class="dropdown-menu testDesignerEntityDropdown">
                            <li class="row strict" *ngFor="let activity of activityTypes; let tabIndex = index">
                              <div class="col-xs-11 col-xs-offset-1 dropdown-item" (click)="changeActivity(activity)">
                                {{activity.name}}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- entity type selection dropdown -->
                  <div class="col col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1 paddingleft3px paddingright3px">
                    <div class="row strict">
                      <div class="col-sm-12 col-xs-12">
                        <div class="dropdown">
                          <button
                            class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                            type="button" data-toggle="dropdown" [ngClass]="{ dis:sprintName == ''}">
                            <!-- [ngClass]="{ dis:fieldsDisabled || EUTTypeDDisabled}" -->
                            <div class="row strict">
                              <div class="col-xs-10">
                                <span *ngIf="selectedEUT!=''">{{selectedEUT}} </span>
                                <span *ngIf="selectedEUT==''">{{'sprintPlanner.chooseEUT' | translate }}</span>
                              </div>
                              <div class="col-xs-1 col-xs-offset-1 pull-right ">
                                <span class="caret"></span>
                              </div>
                            </div>
                          </button>
                          <ul class="dropdown-menu testDesignerEntityDropdown">
                            <li class="row strict" *ngFor="let eut of eutTypes; let tabIndex = index">
                              <div class="col-xs-11 col-xs-offset-1   dropdown-item" (click)="changeEntity(eut)">
                                {{eut}}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- entity/user story desc adding input field -->
                  <div class="col col-xl-7 col-lg-7 col-md-7 col-sm-7 col-xs-7 paddingleft3px paddingright3px">
                    <div class="row strict">
                      <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <input type="text" [ngClass]="{ dis:sprintName == ''}"
                          [placeholder]="'sprintPlanner.userstoryPlaceholder'| translate" [(ngModel)]='userstoryName'
                          class="form-control strict lg-input pl-3 pr-3 taskplanner-inputfield">
                      </div>
                    </div>
                  </div>



                  <!-- attribute selection dropdown -->
                  <div class="col col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-2 paddingleft3px paddingright3px">
                    <div class="row strict">
                      <div class="col-sm-12 col-xs-12">
                        <div class="dropdown">
                          <button
                            class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px"
                            type="button" data-toggle="dropdown" [ngClass]="{ dis:userstoryName == ''}">
                            <div class="row strict">
                              <div class="col-xs-8 span-on-button">
                                {{ 'sprintPlanner.toSatisfyButtonHeading' | translate }}
                                {{ 'sprintPlanner.attButton' | translate }}
                              </div>
                              <div class="col-xs-2 pull-right">
                                <span class="caret"></span>
                              </div>
                            </div>

                          </button>
                          <ul class="dropdown-menu">
                            <li class="row strict" *ngFor="let a of config.listOfAttributes">
                              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-1 col-xl-1">
                                <div style="text-align: center;">
                                  <input class="marginleft3px" (click)="mapEutToAtt(a,$event.target.checked)"
                                    [checked]="isCheckedAtt(a)" type="checkbox">
                                </div>
                              </div>
                              <div class="col-xs-10 col-sm-10 col-md-10 col-lg-11 col-xl-11 dropdown-item pl-2">
                                {{a.name+" ("+a.symbol+")"}}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Jira fetch user stories button -->
                  <!-- <div class="col col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1 paddingleft3px paddingright6px">
                    <div class="row strict">
                      <button type="button" [ngClass]="{ dis:sprintName == ''}"
                        class="btn btn-default btn-block btn-sm tpButton" (click)="selectedSprint(true,true,'')">
                        Jira&nbsp;<fa-icon class="fa menuItemsClrBlack" [icon]="faJira"></fa-icon>
                      </button>
                    </div>
                  </div> -->

                  <!-- Add user story/entity button -->
                  <div class="col col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1 paddingleft3px paddingright3px">
                    <div class="row strict">
                      <button type="button" [ngClass]="{ dis:userstoryName == ''}"
                        class="btn btn-default btn-block btn-sm tpButton" (click)="addTaskToPlanner()">
                        Add&nbsp;<fa-icon class="fa menuItemsClrBlack" [icon]="faPlus"></fa-icon>
                      </button>
                    </div>
                  </div>

                </div>

                <!-- table listing for all existing/jira user stories -->
                <div class="row strict sprint-user-stories-list-table-height" [ngClass]="{ dis:sprintName == ''}">
                  <div class="col-xs-12 table-bordered border-none card p-1 mb-2 bg-white h-100">
                    <table id="taskPlannerListTable"
                      class="table env1 bg-color-black mb-0 h-100 table-bordered tableBackgrdClrBlack menuItemsClrWhite tasksTable">
                      <thead>
                        <tr class="row strict">
                          <th class="col-xs-11 border-right1px">
                            <div class="row strict">
                              <div class="col col-10 col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10">
                                {{'sprintPlanner.description' | translate}}
                              </div>
                              <div class="col col-1 col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1"></div>
                              <div class="col col-1 col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1">
                              </div>
                            </div>
                          </th>
                          <th class="col-xs-1">
                            <div class="row strict">
                              <div class="col col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                {{'taskPlanner1.status' | translate}}
                              </div>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody class="task-planner-tasks-table-body-height">
                        <!-- listing platform entities list -->
                        <tr class="clickable-row border-bottom1px"
                          *ngFor="let entity of modelData.listOfEUTs; let tabIndex = index"
                          class="cursorPointer bg-color-black" (click)="loadEntityDetails(entity)">
                          <td class="col-xs-11 border-right1px border-left1px">
                            ({{entity.eType}})-{{entity.eName}}
                          </td>
                          <td>
                          </td>
                        </tr>
                        <!-- listing jira user stories list -->
                        <tr class="clickable-row border-bottom1px"
                          *ngFor="let story of jiraProjectData; let tabIndex = index"
                          class="cursorPointer bg-color-black">
                          <td class="col-xs-11 border-right1px border-left1px">
                            ({{story.fields.issuetype.name}})-{{story.fields.summary}}
                          </td>
                          <td>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="row strict">
                  <div class="col-xs-1 col-xs-offset-11 col-sm-1 col-sm-offset-11 mapperReadOnly">
                    <button [ngClass]="{dis:!selectedEntity.eID||!sprintName}" type="button"
                      class="btn btn-block btn-default btn-sm tpButton" (click)="nextStep('2')">
                      Next&nbsp;<fa-icon class="fas menuItemsClrBlack" [icon]="faChevronRight"></fa-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row strict h-100" *ngIf="step == '2'">
            <div class="row full-width p-1 h-100">
              <div class="col-xs-12 h-100">
                <div class="row strict">
                  <div class="col-xs-12 menuItemsClrWhite">
                    Select impacted entites for "{{selectedEntity.eName}}"
                  </div>
                </div>
                <div class="row strict">
                  <!-- user story type selection dropdown -->
                  <!-- <div class="col col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1 paddingleft3px paddingright3px">
                    <div class="row strict">
                      <div class="col-sm-12 col-xs-12">

                        <div class="dropdown">
                          <button
                            class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                            type="button" data-toggle="dropdown">
                            <div class="row strict">
                              <div class="col-xs-10 text-flow">
                                <span>{{selectedActivity||'sprintPlanner.chooseIssueType' | translate }}</span>
                              </div>
                              <div class="col-xs-1 col-xs-offset-1 pull-right ">
                                <span class="caret"></span>
                              </div>
                            </div>
                          </button>
                          <ul class="dropdown-menu testDesignerEntityDropdown">
                            <li class="row strict" *ngFor="let activity of activityTypes; let tabIndex = index">
                              <div class="col-xs-11 col-xs-offset-1 dropdown-item" (click)="changeActivity(activity)">
                                {{activity.name}}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div> -->

                  <!-- entity type selection dropdown -->
                  <div class="col col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1 paddingleft3px paddingright3px">
                    <div class="row strict">
                      <div class="col-sm-12 col-xs-12">
                        <div class="dropdown">
                          <button
                            class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                            type="button" data-toggle="dropdown">
                            <div class="row strict">
                              <div class="col-xs-10">
                                <span *ngIf="selectedEUT!=''">{{selectedEUT}} </span>
                                <span *ngIf="selectedEUT==''">{{'sprintPlanner.chooseEUT' | translate }}</span>
                              </div>
                              <div class="col-xs-1 col-xs-offset-1 pull-right ">
                                <span class="caret"></span>
                              </div>
                            </div>
                          </button>
                          <ul class="dropdown-menu testDesignerEntityDropdown">
                            <li class="row strict" *ngFor="let eut of eutTypes; let tabIndex = index">
                              <div class="col-xs-11 col-xs-offset-1   dropdown-item" (click)="changeEntity(eut)">
                                {{eut}}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- entity/user story desc adding input field -->
                  <div class="col col-xl-10 col-lg-10 col-md-10 col-sm-10 col-xs-10 paddingleft3px paddingright3px">
                    <div class="row strict">
                      <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <input type="text" id="taskPlannerInputField" [ngClass]="{ dis:sprintName == ''}"
                          [placeholder]="'sprintPlanner.userstoryPlaceholder'| translate"
                          [(ngModel)]='userstoryNameImpact'
                          class="form-control strict lg-input pl-3 pr-3 taskplanner-inputfield">
                      </div>
                    </div>
                  </div>

                  <!-- attribute selection dropdown -->
                  <!-- <div class="col col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-2 paddingleft3px paddingright6px">
                    <div class="row strict">
                      <div class="col-sm-12 col-xs-12">
                        <div class="dropdown">
                          <button
                            class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px"
                            type="button" data-toggle="dropdown">
                            <div class="row strict">
                              <div class="col-xs-8 span-on-button">
                                {{ 'sprintPlanner.toSatisfyButtonHeading' | translate }} {{ 'sprintPlanner.attButton' |
                                translate }}
                              </div>
                              <div class="col-xs-2 pull-right">
                                <span class="caret"></span>
                              </div>
                            </div>

                          </button>
                          <ul class="dropdown-menu">
                            <li class="row strict" *ngFor="let a of config.listOfAttributes">
                              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-1 col-xl-1">
                                <div style="text-align: center;">
                                  <input class="marginleft3px" (click)="mapEutToAtt(a.symbol,$event.target.checked)"
                                    [checked]="isCheckedAtt(a)" type="checkbox">
                                </div>
                              </div>
                              <div class="col-xs-10 col-sm-10 col-md-10 col-lg-11 col-xl-11 dropdown-item pl-2">
                                {{a.name+" ("+a.symbol+")"}}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div> -->

                  <!-- Jira fetch user stories button -->
                  <!-- <div class="col col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1 paddingleft3px paddingright6px">
                    <div class="row strict">
                      <button type="button" [ngClass]="{ dis:showText==true}"
                        class="btn btn-default btn-block btn-sm tpButton" (click)="selectedSprint(true,true,'')">
                        Jira&nbsp;<fa-icon class="fa menuItemsClrBlack" [icon]="faJira"></fa-icon>
                      </button>
                    </div>
                  </div> -->

                  <!-- Add user story/entity button -->
                  <div class="col col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1 paddingleft3px paddingright3px">
                    <div class="row strict">
                      <button type="button" [ngClass]="{ dis:showText==true}"
                        class="btn btn-default btn-block btn-sm tpButton" (click)="addEUTToImpact()">
                        Add&nbsp;<fa-icon class="fa menuItemsClrBlack" [icon]="faPlus"></fa-icon>
                      </button>
                    </div>
                  </div>

                </div>

                <!-- table listing for all existing/jira user stories -->
                <div class="row strict sprint-user-stories-list-table-height">
                  <div class="col-xs-12 table-bordered border-none card p-1 mb-2 bg-white h-100">
                    <table id="sprintPlannerListTable"
                      class="table env1 bg-color-black mb-0 h-100 table-bordered tableBackgrdClrBlack menuItemsClrWhite tasksTable">
                      <thead>
                        <tr class="row strict">
                          <th class="col-xs-1">
                            <div class="row strict">
                              <div class="col col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                              </div>
                            </div>
                          </th>
                          <th class="col-xs-11 border-right1px">
                            <div class="row strict">
                              <div class="col col-10 col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10">
                                {{'sprintPlanner.description' | translate}}
                              </div>
                              <div class="col col-1 col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1">
                              </div>
                              <div class="col col-1 col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1">
                              </div>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody class="task-planner-tasks-table-body-height">
                        <!-- listing platform entities list -->

                        <tr class="clickable-row border-bottom1px"
                          *ngFor="let entity of modelData.listOfEUTs; let tabIndex = index"
                          class="cursorPointer bg-color-black"
                          [ngClass]="{displayNone: entity.eID == selectedEntity.eID}">
                          <td class="text-flow col-xs-1 border-right1px">
                            <div style="text-align: center;">
                              <input type="checkbox" class="mapperReadOnly" [checked]="isCheckedInter(entity)"
                                (click)="mapEutToImpact(entity,$event.target.checked)">
                            </div>
                          </td>
                          <td class="col-xs-11 border-right1px border-left1px">
                            ({{entity.eType}})-{{entity.eName}}
                          </td>
                        </tr>

                        <!-- listing jira user stories list -->
                        <tr class="clickable-row border-bottom1px"
                          *ngFor="let story of jiraProjectData; let tabIndex = index"
                          class="cursorPointer bg-color-black">
                          <td class="text-flow col-xs-1 border-right1px">
                            <div style="text-align: center;">
                              <input type="checkbox" class="mapperReadOnly">
                            </div>
                          </td>
                          <td class="col-xs-11 border-right1px border-left1px">
                            ({{story.fields.issuetype.name}})-{{story.fields.summary}}
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="row strict">
                  <div class="col-xs-1 col-sm-1 mapperReadOnly">
                    <button [ngClass]="{dis:!selectedEntity.eID||!sprintName}" type="button"
                      class="btn btn-block btn-default btn-sm tpButton" (click)="nextStep('1')">
                      <fa-icon class="fas menuItemsClrBlack" [icon]="faChevronLeft"></fa-icon>&nbsp;Back
                    </button>
                  </div>

                  <div class="col-xs-1 col-xs-offset-10 col-sm-1 col-sm-offset-10 mapperReadOnly">
                    <button type="button" class="btn btn-block btn-default btn-sm tpButton"
                      (click)="nextStep('3');mapImpactedEUTs()">
                      Next&nbsp;<fa-icon class="fas menuItemsClrBlack" [icon]="faChevronRight"></fa-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row strict 100" *ngIf="step == '3'">
            <div class="row full-width p-1 h-100">
              <div class="col-xs-12 h-100">
                <div class="row strict h-10">
                  <div class="col-xs-12 menuItemsClrWhite">
                    Select Impacted area for selected user story description
                  </div>
                </div>
                <div class="row strict h-45">
                  <div class="col col-xs-12 menuItemsClrWhite">
                    <div>
                      Persona selection
                    </div>
                  </div>
                </div>
                <div class="row strict h-45">
                  <div class="col col-xs-12 menuItemsClrWhite">
                    <div>
                      Env selection
                    </div>
                  </div>
                </div>
                <div class="row strict">
                  <div class="col-xs-1 col-sm-1 mapperReadOnly">
                    <button [ngClass]="{dis:!selectedEntity.eID||!sprintName}" type="button"
                      class="btn btn-block btn-default btn-sm tpButton" (click)="nextStep('2')">
                      <fa-icon class="fas menuItemsClrBlack" [icon]="faChevronLeft"></fa-icon>&nbsp;Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
  <!-- Section footer start -->
  <div class="headerBackground card p-1 mt-2 tool-footer-height">
    <div class='row pb-0 pt-0'>
      <div id="taskplannerTip1" class="carousel slide" data-ride="carousel" data-interval="false">
        <!-- Wrapper for slides -->
        <div class="carousel-inner text-color-yellow">
          <div class="row item active text-color-yellow">
            <div class="col-xs-12 align_center carousel-tip-align">
              Tip #1 : {{'taskPlanner1.tip1' | translate}}
            </div>
          </div>
          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align">
              Tip #2 : {{'taskPlanner1.tip2' | translate}}
            </div>
          </div>
          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align">
              Tip #3 : {{'taskPlanner1.tip3' | translate}}
            </div>
          </div>
        </div>
        <!-- Left and right controls -->
        <a class="left carousel-control carousel-tip-align display-flex" data-target="#taskplannerTip1"
          data-slide="prev">
          <span>
            <fa-icon class="fas" [icon]="faChevronLeft"></fa-icon>
          </span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control carousel-tip-align display-flex" data-target="#taskplannerTip1"
          data-slide="next">
          <span>
            <fa-icon class="fas" [icon]="faChevronRight"></fa-icon>
          </span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
  <!-- Section footer end -->

  <!-- Youtube video Modal -->
  <div class="modal fade bd-example-modal-lg" id="ytVideoLinkTP1" tabindex="-1" role="dialog"
    aria-labelledby="ytVideoLinkTP1" aria-hidden="true">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content ytVideoLink">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" (click)="terminateVideo()"
              aria-hidden="true">&times;</button>
            <h4 class="modal-title" id="myModalLabel">{{'youtubeVideoTitle.taskplanner' | translate}}</h4>
          </div>
          <!-- Modal body -->
          <div class="modal-body">
            <iframe width="100%" height="100%" id="Tp1VideoLink" class="youtubeVideo" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- The empty data popup modal -->
  <div class="modal fade" id="taskPlannerMsgPopup1" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px">
                    {{toastMsgPopup}}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer text-align-center">
            <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">
              {{ 'ok' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>